const IMAGES = {
    img1: require('./cleaning.jpg'),
    img2: require('./housecleaning.jpg'),
    img3: require('./officecleaning.jpg'),
    slide1: require('./carosel.jpg'),
    slide2: require('./carosel1.jpg')
}

export default IMAGES